function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.29832 9.63974L9.45673 9.46757C10.3756 8.46887 10.8943 7.16548 10.8943 5.78041C10.8943 2.77203 8.45554 0.333252 5.44716 0.333252C2.43877 0.333252 0 2.77203 0 5.78041C0 8.78879 2.43877 11.2276 5.44716 11.2276C6.44639 11.2276 7.40557 10.9583 8.24368 10.4559L8.40695 10.358L11.5488 13.4999C11.7711 13.7221 12.1314 13.7221 12.3536 13.4999C12.5759 13.2776 12.5759 12.9173 12.3536 12.6951L9.29832 9.63974ZM5.44716 10.0893C3.06739 10.0893 1.13821 8.16017 1.13821 5.78041C1.13821 3.40064 3.06739 1.47146 5.44716 1.47146C7.82692 1.47146 9.7561 3.40064 9.7561 5.78041C9.7561 8.16017 7.82692 10.0893 5.44716 10.0893Z",
  fill: "#373737"
});

function SvgSearchbarSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchbarSearchIcon);
export default __webpack_public_path__ + "static/media/searchbar-search-icon.079d6b89.svg";
export { ForwardRef as ReactComponent };